import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { INITIAL_ADVANCE_FILTER } from 'configs/analytics/configTableProduct'
import { constructOptionsSelect } from 'utils/utils'
import { API_PRODUCT } from 'services/apiAnalyticProduct'
import { AdvanceFilter } from 'components/analytics/product/AdvanceFilter'

export const AdvanceFilterContainer = ({ show, setShow, values, onSubmit }) => {
    const [filterDetail, setFilterDetail] = useState({})
    const { fetching: getBrandList } = useFetch(API_PRODUCT.BRAND_LIST)
    const [optionsBrand, setOptionsBrand] = useState([])

    const getFilterCount = () => {
        let count = 0
        Object.keys(values).map((i) => (count += values[i]?.length))
        return count
    }

    const onClear = () => {
        setFilterDetail(INITIAL_ADVANCE_FILTER)
    }

    const onSearchBrand = (value = '') => {
        getBrandList({ search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'name', 'id')
            setOptionsBrand(newOption)
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setFilterDetail({ ...filterDetail, [name]: value })
    }

    useEffect(() => {
        if (show) onSearchBrand()
        setFilterDetail(values)
    }, [show, values])

    const props = {
        show,
        setShow,
        filterDetail,
        getFilterCount,
        onSearchBrand,
        onChangeForm,
        onClear,
        optionsBrand,
        onSubmit,
    }

    return <AdvanceFilter {...props} />
}
